import _ from "lodash";

export const StorageModeDroOpts = () => {

    const STORAGE_MODE_ROAD = "ROAD";
    const STORAGE_MODE_WATER = "WATER";
    const STORAGE_MODE_COS = "COS";
    const STORAGE_MODE_YH = "YH";

    const getDroOptsModel = () => {
        let ret = [STORAGE_MODE_ROAD, STORAGE_MODE_WATER, STORAGE_MODE_COS, STORAGE_MODE_YH];

        return [
            ...(_.orderBy(ret?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [], "dropdownLabel"))];
    }

    return {
        getDroOptsModel,
    }
}